module.exports = __webpack_public_path__ + "assets/img/travel-day40.17f6a407.png";